import { useCart } from "../context/CartContext";
import { useApp }  from "../context/AppContext";
import Breadcrumb  from "../components/Breadcrumb";

const crumbs = [
  { label: "Home",     page: "home" },
  { label: "Cart" },
];

export default function CartPage() {
  const { items, removeFromCart, updateQty, clearCart, totalItems, totalPrice } = useCart();
  const { navigate } = useApp();

  const isEmpty = items.length === 0;

  return (
    <div className="page-wrap fade-up">
      <Breadcrumb crumbs={crumbs} />

      <div className="cart-page-title-row">
        <h1 className="page-title">🛒 Your Cart</h1>
        {!isEmpty && (
          <button className="cart-clear-btn" onClick={clearCart}>
            Clear all
          </button>
        )}
      </div>

      {isEmpty ? (
        /* ── Empty state ── */
        <div className="empty-state">
          <div className="empty-state-icon">🛒</div>
          <h3>Your cart is empty</h3>
          <p>Browse our Other category to find items you can order online.</p>
          <button
            className="cart-empty-shop-btn"
            onClick={() => navigate("products", "other")}
          >
            Shop Other Products →
          </button>
        </div>
      ) : (
        /* ── Cart content ── */
        <div className="cart-layout">

          {/* Line items */}
          <div className="cart-items-col">
            {items.map((item) => {
              const lineTotal = (item.product.priceNum * item.quantity).toFixed(2);
              return (
                <div key={item.cartItemId} className="cart-item">
                  {/* Emoji thumbnail */}
                  <div className="cart-item-thumb">{item.product.emoji}</div>

                  {/* Info */}
                  <div className="cart-item-info">
                    <div className="cart-item-name">{item.product.name}</div>
                    <div className="cart-item-variant">{item.variant}</div>
                    <div className="cart-item-unit-price">{item.product.price} each</div>
                  </div>

                  {/* Qty stepper */}
                  <div className="cart-item-qty">
                    <button
                      className="cart-qty-btn"
                      onClick={() => updateQty(item.cartItemId, item.quantity - 1)}
                    >−</button>
                    <span className="cart-qty-num">{item.quantity}</span>
                    <button
                      className="cart-qty-btn"
                      onClick={() => updateQty(item.cartItemId, item.quantity + 1)}
                    >+</button>
                  </div>

                  {/* Line total */}
                  <div className="cart-item-total">${lineTotal}</div>

                  {/* Remove */}
                  <button
                    className="cart-item-remove"
                    onClick={() => removeFromCart(item.cartItemId)}
                    title="Remove item"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>

          {/* Order summary sidebar */}
          <div className="cart-summary-col">
            <div className="cart-summary-card">
              <h3 className="cart-summary-title">Order Summary</h3>

              <div className="cart-summary-rows">
                <div className="cart-summary-row">
                  <span>Items ({totalItems})</span>
                  <span>${totalPrice}</span>
                </div>
                <div className="cart-summary-row">
                  <span>Pickup</span>
                  <span className="cart-free">Free</span>
                </div>
              </div>

              <div className="cart-summary-divider" />

              <div className="cart-summary-total">
                <span>Total</span>
                <span>${totalPrice}</span>
              </div>

              <button
                className="cart-checkout-btn"
                onClick={() => navigate("checkout")}
              >
                Checkout →
              </button>

              <p className="cart-summary-note">
                🏪 All orders are for <strong>in-store pickup</strong> at<br />
                London ON.
              </p>

              <button
                className="cart-continue-btn"
                onClick={() => navigate("products", "other")}
              >
                ← Continue Shopping
              </button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
}
